import React, { Fragment, useState } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";

import LoggedInNav from "../layout/IME/LoggedInNav";
import LoggedOutNav from "../layout/IME/LoggedOutNav";
import TwoFARequest from "../layout/Innovators/TwoFARequest";
import LiveDiscussionSearchInput from "../layout/Innovators/LiveDiscussionSearchInput";
import LiveDiscussionsFeature from "../layout/Innovators/LiveDiscussionsFeature";
import MiniDiscussionStream from "../layout/Innovators/MiniDiscussionStream";

const LiveOnIMEDiscussions = ({
  auth: { user, channelid, jobtitle, location, verified },
  isAuthenticated,
}) => {
  const [view, setView] = useState({
    one: true,
    four: false,
    eight: false,
  });
  const [showAuthentication, setShowAuthentication] = useState(true);

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.channelid !== "roland") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      {verified && !isAuthenticated && (
        <TwoFARequest
          setShowAuthentication={setShowAuthentication}
          channelid={channelid}
          jobtitle={jobtitle}
          location={location}
        />
      )}
      {isAuthenticated && <LoggedInNav />}
      {!isAuthenticated && <LoggedOutNav />}
      <div className="flex-all-content-fixed">
        <LiveDiscussionSearchInput />
        <LiveDiscussionsFeature />
        <div className="active-view-live-ime">
          <div
            onClick={() => setView({ one: true, four: false, eight: false })}
            className="section-title green"
          >
            1-on-1
            {view.one && <i className="far fa-check-circle mx-5 green"></i>}
          </div>
          <div
            onClick={() => setView({ one: false, four: true, eight: false })}
            className="section-title green"
          >
            Panel
            {view.four && <i className="far fa-check-circle mx-5 green"></i>}
          </div>
          <div
            onClick={() => setView({ one: false, four: false, eight: true })}
            className="section-title green"
          >
            Group
            {view.eight && <i className="far fa-check-circle mx-5 green"></i>}
          </div>
        </div>
        {view.one && (
          <section className="results">
            <div class="live-results">
              <div class="results-section-items green">
                <p class="results-p">
                  1-on-1
                  <span class="white mx-5">Discussions</span>
                </p>
              </div>
            </div>
            <hr class="background-green" />
            <div className="created-content">
              <div className="content-container">
                <div className="stream-result">
                  <MiniDiscussionStream />
                </div>
              </div>
              <div className="content-container">
                <div className="stream-result">
                  <MiniDiscussionStream />
                </div>
              </div>
              <div className="content-container">
                <div className="stream-result">
                  <MiniDiscussionStream />
                </div>
              </div>
            </div>
          </section>
        )}
        {view.four && (
          <section className="results">
            <div class="live-results">
              <div class="results-section-items green">
                <p class="results-p">
                  4-Person Panel
                  <span class="white mx-5">Discussions</span>
                </p>
              </div>
            </div>
            <hr class="background-green" />
            <div className="created-content">
              <div className="content-container">
                <div className="stream-result">
                  <MiniDiscussionStream />
                </div>
              </div>
              <div className="content-container">
                <div className="stream-result">
                  <MiniDiscussionStream />
                </div>
              </div>
              <div className="content-container">
                <div className="stream-result">
                  <MiniDiscussionStream />
                </div>
              </div>
            </div>
          </section>
        )}
        {view.eight && (
          <section className="results">
            <div class="live-results">
              <div class="results-section-items green">
                <p class="results-p">
                  Group
                  <span class="white mx-5">Discussions</span>
                </p>
              </div>
            </div>
            <hr class="background-green" />
            <div className="created-content">
              <div className="content-container">
                <div className="stream-result">
                  <MiniDiscussionStream />
                </div>
              </div>
              <div className="content-container">
                <div className="stream-result">
                  <MiniDiscussionStream />
                </div>
              </div>
              <div className="content-container">
                <div className="stream-result">
                  <MiniDiscussionStream />
                </div>
              </div>
            </div>
          </section>
        )}
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps)(LiveOnIMEDiscussions);
